import {isTouch} from 'app/utils/platform';

globalThis.__TOUCH__ = isTouch();
